// extracted by mini-css-extract-plugin
export var tosLink = "_aa-0";